export default __webpack_public_path__ + "static/media/banner-1.164a7e51.jpg";